// LAB-988 admin campaign report palette. 5-color diverging scale matching the
// mockup: pinks on the "low" side, cream neutral in the middle, indigos on the
// "high" side. Not promoted to design-system tokens yet since these are only
// used inside the reflections admin report.
export const SEGMENT_COLORS = [
    "#cd2f7b", // Rarely — pink
    "#f6a6c5", // Occasionally — light pink
    "#e7e2db", // Sometimes — cream
    "#b7b2ee", // Often — light indigo
    "#7e78de", // Consistently — indigo
] as const;

// Middle 3 swatches are light enough that white % labels are unreadable — use
// the dark text variant on those.
export const LIGHT_SWATCH_INDICES = new Set([1, 2, 3]);

export const SEGMENT_LABELS: readonly string[] = ["Rarely", "Occasionally", "Sometimes", "Often", "Consistently"];
